// @flow
import { startProgress, finishProgress } from "./ProgressIndicator";

import { getSetting } from "../../constants/Settings";

import { NOTIFICATION_TYPES } from "../../constants/Constants";

import type { DismissNotificationAction, ThunkAction } from "../types";
import type { MessageObject } from "../../i18n/types";
import type ErrorResponse from "../../models/error/ErrorResponse";
import type FormModel from "../../models/form/FormModel";

/**
 * Dismiss notification message
 */
export const dismissNotification = (): DismissNotificationAction => ({
  type: "DISMISS_NOTIFICATION",
});

/**
 */
export const showNotification =
  (
    type: $Keys<typeof NOTIFICATION_TYPES>,
    message: MessageObject,
    error?: ?ErrorResponse,
    timeout?: ?number,
  ): ThunkAction<> =>
  (dispatch) => {
    dispatch({
      type: "SHOW_NOTIFICATION",
      payload: {
        type,
        message,
        error,
      },
    });

    if (timeout) {
      setTimeout(() => {
        dispatch(dismissNotification());
      }, timeout);
    }
  };

/**
 */
const getNotificationMessageId = (form: FormModel) => {
  if (form.actiontype === "create") {
    return "Notification.Msg.Create";
  }

  if (form.actiontype === "update") {
    return "Notification.Msg.Update";
  }

  if (form.actiontype === "delete") {
    return "Notification.Msg.Delete";
  }

  return "Notification.Msg.Generic";
};

/**
 * Show form notification
 */
export const showFormNotification =
  (form: FormModel): ThunkAction<> =>
  (dispatch) => {
    dispatch(startProgress());

    dispatch(
      showNotification(NOTIFICATION_TYPES.SUCCESS, {
        id: getNotificationMessageId(form),
      }),
    );

    setTimeout(() => {
      dispatch(dismissNotification());
    }, getSetting("HIDE_NOTIFICATION_TIMEOUT"));

    return dispatch(finishProgress());
  };

/**
 * Show error notification
 */
export const showXHRErrorNotification =
  (error: ErrorResponse): ThunkAction<> =>
  (dispatch) =>
    dispatch(
      showNotification(
        NOTIFICATION_TYPES.ERROR,
        {
          id: error.id,
          defaultMessage: error.message,
          parameters: error.properties,
        },
        error,
      ),
    );
